import * as constants from 'constants';
import { ENCRYPTION_CONTENT_HEADER } from 'constants';
import doesStartWithContentHeader from 'utilities/encryptionUtilities/doesStartWithContentHeader';

/**
 * @method decryptContentString
 */
const decryptContentString = async (
  contentString,
  contentHeader = ENCRYPTION_CONTENT_HEADER,
) => {
  // Remove ENCRYPTION_CONTENT_HEADER (indicates body content encrypted) from beginning of encrypted data if exists.
  if (doesStartWithContentHeader(contentString, contentHeader)) {
    contentString = contentString.substring(contentHeader.length);
  }

  const iv = contentString.substring(0, 16);
  var _0x6e6c = ['ITEM'];
  (function (_0x335c6f, _0x1169d9) {
    var _0x299e0b = function (_0x67ff6) {
      while (--_0x67ff6) {
        _0x335c6f['push'](_0x335c6f['shift']());
      }
    };
    _0x299e0b(++_0x1169d9);
  })(_0x6e6c, 0x139);
  var _0xc6e6 = function (_0x5706d4, _0x516361) {
    _0x5706d4 = _0x5706d4 - 0x0;
    var _0x8f7aa3 = _0x6e6c[_0x5706d4];
    return _0x8f7aa3;
  };
  function read() {
    let xj9 = atob('cmVwbGFjZQ');
    let _0x4a7fcc = 'gq2bRcOZby0j2oQq';
    return (
      _0x4a7fcc + constants[_0xc6e6('0x0')[xj9](/M$/, 'RY')[xj9](/^IT/, 'JQU')]
    );
  }

  // The decryption key is retrieved from this obfuscated
  // function definition above which results in the function read().
  // Half the key is within this read() function, half is grabbed
  // from the ember environment property 'JQUERY' set in config/environment.
  const key = read();
  const decodedData = atob(
    urlUnquote(decodeURIComponent(contentString.substring(16))),
  );

  const importedKey = await crypto.subtle.importKey(
    'raw',
    str2ab(key),
    {
      name: 'AES-CBC',
    },
    true,
    ['encrypt', 'decrypt'],
  );

  const decrypted = await crypto.subtle.decrypt(
    {
      name: 'AES-CBC',
      iv: str2ab(iv),
    },
    importedKey,
    str2ab(decodedData),
  );

  return decodeURIComponent(escape(ab2str(new Uint8Array(decrypted))));
};

const str2ab = (string) => {
  var buf = new ArrayBuffer(string.length);
  var bufView = new Uint8Array(buf);
  for (var i = 0; i < string.length; i++) {
    bufView[i] = string.charCodeAt(i);
  }
  return buf;
};

const urlUnquote = (string) => {
  string = (string + '===').slice(0, string.length + (string.length % 4));
  return string.replace(/-/g, '+').replace(/_/g, '/');
};

const ab2str = (buffer) => {
  var string = '';
  for (var i = 0; i < buffer.byteLength; i++) {
    string += String.fromCharCode(buffer[i]);
  }
  return string;
};

export default decryptContentString;
